import { toast } from "react-hot-toast";
import { actionType } from "../utils/helpers/generalHelper";
import * as CartConstants from "../constants/cart.constant";
import CartService from "../services/cart.service";
import ErrorHelper from "../utils/helpers/errorHelper";
import * as ModalConstants from "../constants/modal.constant";
import ModalTypesEnum from "../utils/mapper/enums/ModalTypesEnum";

export const addToCart = (payload, desc) => async (dispatch) => {
  try {
    dispatch(actionType(CartConstants.ADD_TO_CART_REQUEST));
    const data = await CartService.addItemToCart(payload);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(actionType(CartConstants.ADD_TO_CART_SUCCESS, data.data));
    dispatch(
      actionType(ModalConstants.SHOW_MODAL, {
        data: desc,
        type: ModalTypesEnum.DOCUMENT_REQUEST,
      })
    );
    // toast.success("Document added to cart successfully");
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(CartConstants.ADD_TO_CART_ERROR));
    toast.error(message);
  }
};

export const getCartNoFee = (addAlumniFee) => async (dispatch) => {
  try {
    dispatch(actionType(CartConstants.FETCH_CART_NO_FEE_REQUEST));
    const data = await CartService.fetchAll(addAlumniFee);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(actionType(CartConstants.FETCH_CART_NO_FEE_SUCCESS, data.data));
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(CartConstants.FETCH_CART_NO_FEE_ERROR));
    toast.error(message);
  }
};

export const getCart = (addAlumniFee) => async (dispatch) => {
  try {
    dispatch(actionType(CartConstants.FETCH_CART_REQUEST));
    const data = await CartService.fetchAll(addAlumniFee);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(actionType(CartConstants.FETCH_CART_SUCCESS, data.data));
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(CartConstants.FETCH_CART_ERROR));
    toast.error(message);
  }
};

export const removeCartItem = (id, reload) => async (dispatch) => {
  try {
    dispatch(
      actionType(CartConstants.REMOVE_CART_ITEM_REQUEST, {
        loading: true,
        id,
      })
    );
    const data = await CartService.removeItem(id);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(
      actionType(CartConstants.REMOVE_CART_ITEM_SUCCESS, {
        loading: false,
        id,
      })
    );
    dispatch(getTotalCartItems());
  } catch (error) {
    console.error(error);
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(
      actionType(CartConstants.REMOVE_CART_ITEM_ERROR, {
        loading: false,
        id,
      })
    );
    toast.error(message);
  }
};

export const removeAllCartItem = () => async (dispatch) => {
  try {
    dispatch(actionType(CartConstants.REMOVE_ALL_CART_ITEM_REQUEST));
    const data = await CartService.removeAllCartItem();
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(actionType(CartConstants.REMOVE_ALL_CART_ITEM_SUCCESS, data.data));
    dispatch(getTotalCartItems());
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(CartConstants.REMOVE_ALL_CART_ITEM_ERROR));
    toast.error(message);
  }
};

export const getTotalCartItems = () => async (dispatch) => {
  try {
    dispatch(actionType(CartConstants.FETCH_TOTAL_CART_ITEMS_REQUEST));
    const data = await CartService.totalItems();
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(
      actionType(CartConstants.FETCH_TOTAL_CART_ITEMS_SUCCESS, data.data)
    );
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(CartConstants.FETCH_TOTAL_CART_ITEMS_ERROR));
    toast.error(message);
  }
};
